
import { 
  doc, 
  getDoc,
  updateDoc,
  serverTimestamp, 
  Firestore,
  Timestamp
} from "firebase/firestore";
import { CampLocation } from "@/types/campLocation";
import { processLocationDataForStorage } from "./versionDataProcessingService";

/**
 * Updates an existing location version
 */
export const updateLocationVersion = async (
  db: Firestore,
  versionId: string,
  locationData: CampLocation,
  userId: string,
  changeDescription: string = '',
  customTimestamp?: Timestamp,
  isNamedVersion: boolean = false
) => {
  try {
    console.log(`[versionUpdateService] Updating version ${versionId} with userId=${userId}, isNamedVersion=${isNamedVersion}, changeDesc=${changeDescription}`);
    
    const versionRef = doc(db, "campLocationVersions", versionId);
    const userRef = userId !== "system" ? doc(db, "users", userId) : null;
    
    // Get current version data to preserve version number
    const versionSnapshot = await getDoc(versionRef);
    const versionData = versionSnapshot.data();
    const versionNumber = versionData?.versionNumber || 0;
    console.log(`[versionUpdateService] Preserving version number: ${versionNumber}`);
    
    // Process the location data for storage (clean and format)
    const cleanedData = await processLocationDataForStorage(db, locationData);
    
    // Update the version document
    const updateVersionData = {
      data: cleanedData,
      timestamp: customTimestamp || serverTimestamp(),
      user: userRef,
      changeDescription: changeDescription,
      versionNumber: versionNumber,
      isNamedVersion: isNamedVersion || (changeDescription ? changeDescription.length > 0 : false)
    };
    
    await updateDoc(versionRef, updateVersionData);
    console.log(`[versionUpdateService] Updated location version: ${versionId}`);
    
    // Update the location document to reference this version as latest
    await updateVersionReference(db, locationData.id, versionId);
    
    return versionId;
  } catch (error) {
    console.error("[versionUpdateService] Error updating location version:", error);
    throw error;
  }
};

/**
 * Updates the location document to reference the latest version
 */
const updateVersionReference = async (
  db: Firestore,
  locationId: string,
  versionId: string
) => {
  const locationRef = doc(db, "campLocations", locationId);
  await updateDoc(locationRef, {
    latestVersionId: versionId
  });
  
  console.log(`[versionUpdateService] Updated location ${locationId} to reference version ${versionId}`);
  return true;
};
